/**
 * Global sync queue provider — runs background sync for offline mutations.
 * Mount once at app root level.
 */

import { useEffect } from 'react';
import { useSyncQueue } from '../hooks/useSyncQueue.js';

export function SyncQueueProvider({ children }: { children: React.ReactNode }) {
  const { pendingCount, isSyncing, processQueue } = useSyncQueue();

  // Attempt sync on mount if items are pending
  useEffect(() => {
    if (pendingCount > 0 && navigator.onLine) {
      processQueue();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <>{children}</>;
}
